import { isMissingDerivedLayerField } from 'components/form/formHelpers'
import React from 'react'

import { BaseFormField, BaseFormFieldProps } from './BaseFormField'

interface ToggleFormFieldProps extends BaseFormFieldProps {
  canEditField: boolean
  canReadField: boolean
  inEditMode: boolean
  inResolveMode?: boolean
}

export const ToggleFormField: React.FC<ToggleFormFieldProps> = ({
  formItemKey,
  formField,
  fieldValue,
  fieldUnits,
  canEditField,
  units,
  inEditMode,
  inResolveMode,
  formControl,
  formSetValue,
  formErrors,
  showLabel = true,
  formTrigger,
}) => {
  const fieldColor =
    isMissingDerivedLayerField(formField) && inResolveMode
      ? 'warning'
      : 'default'
  const fieldMode =
    (inEditMode || fieldColor === 'warning') && canEditField ? 'edit' : 'read'

  return (
    <BaseFormField
      showLabel={showLabel}
      fieldUnits={fieldUnits}
      fieldValue={fieldValue}
      formItemKey={formItemKey}
      formField={formField}
      formControl={formControl}
      formSetValue={formSetValue}
      formErrors={formErrors}
      formTrigger={formTrigger}
      units={units}
      fieldMode={fieldMode}
      fieldColor={fieldColor}
    />
  )
}
